<template>
  <div ref="layout" class="page-form">
    <h3 class="title">客户信息维护</h3>

    <div class="container">
      <div class="tools" style="margin-bottom: 10px">
        <form-button name="返回" @click="$router.go(-1)" />
      </div>

      <div class="table-container">
        <!-- 发货审批 -->
        <TableCommon
          title="发货审批设置"
          :custome-config="() => vxeShowCustom('xTableApprove')"
        >
          <template #button>
            <table-button name="save" tip="保存" @click="saveAP" />
          </template>
          <vxe-grid
            ref="xTableApprove"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="auto"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: false }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptionsApprove.columns"
            :data="gridOptionsApprove.data"
          >
            <template v-for="item in gridOptionsApprove.columns" #[item.field]="{ row }">
              <div :key="item.field">
                <el-input v-if="item.field !== 'affairPlanPeopleName'" v-model="row[item.field]" size="mini" clearable @clear="clearApprove(item.field)" @focus="openDialog($event, '人员选择', item.field)" />
                <el-input v-else-if="item.field === 'affairPlanPeopleName' && row.byClient == 0" size="mini" :value="row[item.field]" @focus="showSaleApprove" />
                <el-input v-else-if="item.field === 'affairPlanPeopleName' && row.byClient == 1" v-model="row[item.field]" size="mini" clearable @clear="clearApprove(item.field)" @focus="openDialog($event, '人员选择', item.field)" />
              </div>
            </template>
          </vxe-grid>
        </TableCommon>

        <TableCommon
          title="客户关系"
          :custome-config="() => vxeShowCustom('xTable3')"
        >
          <template #button>
            <table-button name="save" tip="保存" @click="saveData" />
            <table-button name="add" tip="增加" @click="insertData" />
            <table-button name="delete" tip="删除" @click="removeData" />
          </template>
          <vxe-grid
            ref="xTable3"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{name: 'NotData'}"
            :edit-rules="validRules"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <template #RELTYP="{ row }">
              <el-select
                v-model="row.RELTYP"
                size="mini"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['A0066']"
                  :key="selectItem.value"
                  :label="selectItem.name"
                  :value="selectItem.value"
                  :disabled="selectItem.disabled"
                />
              </el-select>
            </template>
            <template #PARTNER2="{ row }">
              <wly-input
                v-model="row.PARTNER2"
                input-type="customer"

                @enter="handleEnter(...arguments, row)"
                @handleSuffixClick="showClient($event, row)"
              />
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="人员选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
      destroy-on-close
    >
      <template v-if="showDialog">
        <staff-select ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="showComponentDialog"
      width="70%"
      append-to-body
      title="营销战区销售内勤审批人设置"
    >
      <vxe-grid
        ref="xTableApprove"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{name: 'NotData'}"
        :toolbar-config="{ custom: false }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="saleApproveGridOptions.columns"
        :data="saleApproveGridOptions.data"
      >
        <template v-for="item in saleApproveGridOptions.columns" #[item.field]="{ row }">
          <div :key="item.field">
            <el-input v-model="row[item.field]" size="mini" clearable @clear="clearSaleApprove(item.field, row)" @focus="openStaffDialog($event, '人员选择', item.field, row)" />
          </div>
        </template>
      </vxe-grid>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showComponentDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="subApprove"
        >确认</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="clientDialog" title="客户选择" width="70%">
      <ClientSelect ref="ClientSelect" mode="RELATION" />
      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="clientDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="confirmClient">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

import { apiSaveOrUpdateApprove, apiFindCustomerApprove, apiFindSaleManager, apiSaveSaleManagerByCenter } from '@/api/client'
import { getClientDetail, clientSave } from '@/api/sap/client-sap'
import StaffSelect from '@/components/dialog/StaffSelect.vue'
import ClientSelect from '@/components/dialog/ClientSelect.vue'

export default {
  components: {
    StaffSelect,
    ClientSelect
  },
  data() {
    return {
      clientData: null,
      loading: false,
      showComponentDialog: false,
      showDialog: false,
      employeeControl: '',
      clientDialog: false,
      ChannelXID: '',
      currentSaleRow: null,
      currentRow: null,
      selectDataOptions: {},
      validRules: {
        relationshipType: [
          { required: true }
        ]
      },
      saleApproveGridOptions: {
        columns: [
          { field: 'saleCenter', title: '营销战区编码', width: 160 },
          { field: 'saleCenterName', title: '营销战区名称', width: 160 },
          { field: 'saleManagerName', title: '销售内勤名称1', slots: { default: 'saleManagerName' }},
          { field: 'saleManagerName2', title: '销售内勤名称2', slots: { default: 'saleManagerName2' }},
          { field: 'saleManagerName3', title: '销售内勤名称3', slots: { default: 'saleManagerName3' }},
          { field: 'datum', title: '最后更改日期' },
          { field: 'createdByName', title: '更改人' }
        ],
        data: []
      },
      gridOptionsApprove: {
        columns: [
          { field: 'channelManagerName', title: '渠道经理', slots: { default: 'channelManagerName' }},
          { field: 'baseManagerName', title: '基地总经理', slots: { default: 'baseManagerName' }},
          { field: 'areaManagerName', title: '战区总经理', slots: { default: 'areaManagerName' }},
          { field: 'affairPlanPeopleName', title: '销售内勤', slots: { default: 'affairPlanPeopleName' }},
          { field: 'datum', title: '最后更改日期' },
          { field: 'createdByName', title: '更改人' }
        ],
        data: [
          {
            customerCode: '',
            id: '',
            channelManager: '',
            channelManagerName: '',
            baseManager: '',
            baseManagerName: '',
            areaManager: '',
            areaManagerName: '',
            datum: '',
            corePlanPeople: '',
            corePlanPeopleName: '',
            corePlanPeople2: '',
            corePlanPeople2Name: '',
            affairPlanPeople: '',
            affairPlanPeopleName: '',
            reservedName1: '',
            reservedCode1: '',
            reservedCode2: '',
            reservedName2: ''
          }
        ]
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          {
            field: 'RELTYP',
            title: '关系类型',
            slots: { default: 'RELTYP' }
          },
          { field: 'PARTNER2', title: '关系客户', slots: { default: 'PARTNER2' }},
          { field: 'NAME_ORG1', title: '客户描述' },
          { field: 'PHONE', title: '电话' }
        ],
        data: []
      },
      disabledData: []
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0066')
    if (this.$route.query?.code) {
      this.getInfo()
    }
  },
  methods: {
    async getInfo() {
      this.loading = true

      try {
        const { DATA } = await getClientDetail({ PARTNER: this.$route.query.code })
        const approve = await apiFindCustomerApprove({ customerCode: this.$route.query.code })
        this.clientData = DATA
        this.gridOptionsApprove.data = [approve?.data || {}]
        this.gridOptions.data = DATA.RELATION.filter(item => item.RELTYP === 'BUR011')
        this.disabledData = DATA.RELATION.filter(item => item.RELTYP !== 'BUR011')
      } catch (e) {
        //
        this.clientData = {}
      }

      this.loading = false
    },
    async showSaleApprove(e) {
      e.target.blur()
      const params = this.saleCenterGridOptions.data.map(v => v.ZZFLD00001H)
      const { data } = await apiFindSaleManager(params)
      this.saleApproveGridOptions.data = data
      this.showComponentDialog = true
    },
    showClient(e, row) {
      this.clientDialog = true
      this.currentRow = row
      e.target.blur()
    },
    openStaffDialog(e, title, field, row) {
      e.target.blur()
      //   this.dialogTitle = title
      this.employeeControl = field
      this.currentSaleRow = row
      this.showDialog = true
    },
    openDialog(e, title, option, ChannelXID = '') {
      e.target.blur()
      //   this.dialogTitle = title
      this.showDialog = true
      if (title === '人员选择') {
        this.employeeControl = option
        this.ChannelXID = ChannelXID
      }
    },
    handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.currentRow = row

      this.currentRow.PARTNER2 = data.customerCode
      this.currentRow.NAME_ORG1 = data.name_org1
      this.currentRow.PHONE = data.zzfld000019
    },
    async confirmClient() {
      const data = await this.$refs.ClientSelect.submitForm()
      if (!data) return

      this.currentRow.PARTNER2 = data.customerCode
      this.currentRow.NAME_ORG1 = data.name_org1
      this.currentRow.PHONE = data.zzfld000019
      this.clientDialog = false
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (this.showComponentDialog === true) {
        this.confirmSaleApprove(data)
      } else {
        this.confirmEmployeer(data)
      }
    },
    // 确认人员选择
    async confirmEmployeer(data) {
      switch (this.employeeControl) {
        case 'channelManagerName':
          this.gridOptionsApprove.data[0].channelManagerName = data.name
          this.gridOptionsApprove.data[0].channelManager = data.code
          break
        case 'baseManagerName':
          this.gridOptionsApprove.data[0].baseManagerName = data.name
          this.gridOptionsApprove.data[0].baseManager = data.code
          break
        case 'areaManagerName':
          this.gridOptionsApprove.data[0].areaManagerName = data.name
          this.gridOptionsApprove.data[0].areaManager = data.code
          break
        case 'corePlanPeopleName':
          this.gridOptionsApprove.data[0].corePlanPeopleName = data.name
          this.gridOptionsApprove.data[0].corePlanPeople = data.code
          break
        case 'corePlanPeople2Name':
          this.gridOptionsApprove.data[0].corePlanPeople2Name = data.name
          this.gridOptionsApprove.data[0].corePlanPeople2 = data.code
          break
        case 'affairPlanPeopleName':
          this.gridOptionsApprove.data[0].affairPlanPeopleName = data.name
          this.gridOptionsApprove.data[0].affairPlanPeople = data.code
          break
        case 'reservedName1':
          this.gridOptionsApprove.data[0].reservedName1 = data.name
          this.gridOptionsApprove.data[0].reservedCode1 = data.code
          break
        case 'reservedName2':
          this.gridOptionsApprove.data[0].reservedName2 = data.name
          this.gridOptionsApprove.data[0].reservedCode2 = data.code
          break
      }
      this.showDialog = false
    },
    // 确认销售内勤选择人员
    confirmSaleApprove(data) {
      this.currentSaleRow[this.employeeControl] = data.name
      this.currentSaleRow[this.employeeControl.replace('Name', '')] = data.code
      this.showDialog = false
    },
    async saveAP() {
      try {
        const [data] = this.gridOptionsApprove.data
        data.customerName = this.clientData.INFO.NAME_ORG1
        data.customerCode = this.clientData.INFO.PARTNER
        const { status } = await apiSaveOrUpdateApprove(data)
        if (status != 2) {
          this.$message.success('保存成功！')
          const approve = await apiFindCustomerApprove({ customerCode: this.clientData.INFO.PARTNER })
          this.gridOptionsApprove.data = [approve.data || {}]
        }
      } catch (e) {
        this.$message.error('发货审批设置失败！')
        return
      }
    },
    async subApprove() {
      await apiSaveSaleManagerByCenter(this.saleApproveGridOptions.data)
      this.$message.success('设置成功！')
      const approve = await apiFindCustomerApprove({ customerCode: this.clientData.INFO.PARTNER })
      this.gridOptionsApprove.data = [approve.data || {}]
      this.showComponentDialog = false
    },
    clearSaleApprove(field, row) {
      this.currentSaleRow = row
      this.currentSaleRow[field.replace('Name', '')] = ''
    },
    insertData() {
      const insertData = {
        PARTNER: this.PARTNER,
        RELTYP: '',
        PARTNER2: '',
        NAME_ORG1: '',
        PHONE: '',
        new: true
      }
      this.gridOptions.data.unshift(insertData)
    },
    removeData() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()
      // if (checkedList.some(v => !v.new)) {
      //   return this.$message.error('请不要修改旧数据！')
      // }

      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    async saveData() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.clientData,
        RELATION: [...this.gridOptions.data, ...this.disabledData]
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const { MSGTYPE, MESSAGE } = await clientSave(params)
        if (MSGTYPE === 'S') {
          this.$message.success(MESSAGE)
          await this.getInfo()
        } else {
          this.$message.error(MESSAGE)
        }
      } catch (e) {
        //
        loading.close()
      }
      loading.close()
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
          if (dictcode === 'A0066') {
            response.data.Rows.forEach(item => {
              if (item.value !== 'BUR011') {
                item.disabled = true
              }
            })
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
    padding: 0 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/maintenanceEdit.vue